/**
 * @name setSmoothScroll.js
 * @description スムーススクロール
 * @param {Object} toTopBtn トップへ戻るボタン要素

*/
const toTopBtn = document.getElementById('toTopBtn');

export function setSmoothScroll() {
    loadSmoothScrollTo();
    scrollToTopBtn();
}

/**
 * @name loadSmoothScrollTo
 * @description ページ読み込み時にスムーススクロールを実行する
 */
const loadSmoothScrollTo = () => {
    window.addEventListener('load', () => {
        let hash = location.hash;
        let headerHeight = document.querySelector('header').offsetHeight;
        if (hash) {
            let targetId = document.getElementById(hash.replace('#', ''));
            let targetOffsetTop = window.pageYOffset + targetId.getBoundingClientRect().top - headerHeight;
            setTimeout(() => {
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: 'smooth'
                });
            }, 1);
        }
    })
};

/**
 * @name scrollToTopBtn
 * @description トップへ戻るボタンを押下時にページトップへスクロールする
 */
function scrollToTopBtn() {
    toTopBtn ? toTopBtn.addEventListener('click', scrollToTop) : null;

    function scrollToTop() {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }
}